import React, { Component } from "react";
import {
    Modal, Form, Input,
    FormInstance, DatePicker,
} from "antd";
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment'

interface FormProps {
    disableTime: any
    data: any
    failData: string,
    confirmLoading: boolean,
    visible: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

class NewMerchant extends Component<FormProps> {

    formRelf;
    constructor(props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    disabledDate = (current) => {
        let disableTime = this.props.disableTime;
        return current && (
            current < moment().startOf('day') ||
            current > moment(disableTime).endOf('day')
        );
    }

    onCreate = () => {
        const { onCreate } = this.props;
        this.formRelf.current!.validateFields().then(values => {
            console.log({ values });
            onCreate(values);
        }).catch(info => {
            console.log('Valide Failed:', info);
        })
    }

    onCancel = () => {
        this.props.onCancel();
    }

    render() {

        const {
            visible, confirmLoading,
            data, failData,
        } = this.props;
        const account = data.account || {};
        const license = data.license || {};

        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 19 },
        };

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                confirmLoading={confirmLoading}
                title='创建商户'
                width={520}
                okText='保存'
                cancelText='取消'
                onCancel={this.onCancel}
                onOk={this.onCreate}
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    className="newMerchant-form"
                    initialValues={{
                        name: data.name,
                        accountName: account.mobileNumber || account.email,
                        time: license.expireTime && moment((new Date(license.expireTime)).valueOf()),
                    }}
                >
                    <Form.Item label='商户名称' name="name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="管理员账号" name="accountName" rules={[{ required: true }]} >
                        <Input placeholder="请输入员工手机号/邮箱" />
                    </Form.Item>
                    <Form.Item label="使用权限" name="time" rules={[{ required: true }]}>
                        <DatePicker
                            showTime
                            locale={locale}
                            disabledDate={this.disabledDate}
                        />
                    </Form.Item>
                </Form>
                <p className="error-center">{failData}</p>
            </Modal>
        )
    }
}

export default NewMerchant